import React from 'react';

const DrilledHoleVisualization = ({ data, holeID }) => {
  const colorRanges = [
    [0, 0.6, 'blue'],    // Green for 0-1.0 g/t
    [0.6, 1.0, 'green'],  // Red for 1.0-1.5 g/t
    [1.0, 1.5, 'yellow'],   // Purple for 1.5+ g/t
    [1.5, 2, 'pink'],   // Purple for 1.5+ g/t
    [2, 999, 'red']   // Purple for 1.5+ g/t
  ];

  const getColorForGrade = (grade) => {
    const numericGrade = parseFloat(grade.replace(' g/t', ''));
    for (const [min, max, color] of colorRanges) {
      if (numericGrade >= min && numericGrade < max) {
        return color;
      }
    }
    return '#cccccc'; // Default gray
  };

  const barHeight = 30; // Height of each bar in pixels
  const spacing = 5; // Spacing between bars

  return (
    <div className="drilled-hole-visualization bg-white p-4 rounded-lg shadow-md">
      <h3 className="text-lg font-semibold mb-4">Drilled Hole: {holeID}</h3>
      
      <div className="flex">
        {/* Main visualization */}
        <div className="flex-1">
          <div className="relative" style={{ height: `${data.length * (barHeight + spacing)}px` }}>
            {data.map((item, index) => {
              const grade = parseFloat(item.grade.replace(' g/t', ''));
              const color = getColorForGrade(item.grade);
              
              return (
                <div 
                  key={index}
                  className="flex items-center mb-1"
                  style={{ 
                    position: 'absolute',
                    top: `${index * (barHeight + spacing)}px`,
                    width: '100%'
                  }}
                >
                  {/* Depth labels */}
                  <div className="text-xs text-gray-600 text-right mr-2" style={{ flex: '2' }}>
                    {item.from} - {item.to}
                  </div>
                  
                  {/* Colored bar */}
                  <div 
                    className="rounded"
                    style={{
                      flex: '1',
                      height: `${barHeight}px`,
                      backgroundColor: color,
                      border: '1px solid #ccc'
                    }}
                  />
                  
                  {/* Grade label */}
                  <div className="text-xs text-gray-800 ml-2 font-medium" style={{ flex: '2' }}>
                    {item.grade}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      
      {/* Legend */}
      <div className="mt-6 p-3 bg-gray-50 rounded">
        <h4 className="text-sm font-semibold mb-2">Grade Legend</h4>
        <div className="flex flex-wrap gap-4">
          {colorRanges.map(([min, max, color], index) => (
            <div key={index} className="flex items-center">
              <div 
                className="w-4 h-4 rounded mr-2"
                style={{ backgroundColor: color, border: '1px solid #ccc' }}
              />
              <span className="text-xs">
                {min} - {max === 999 ? '∞' : max} g/t
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DrilledHoleVisualization;
